import {BaseThunkType, InferActionTypes} from "../../../store";
import {api, PaymentType} from "./api";
import {getLang} from "../../../api/types";

export const actions = {
    setLoading: (loading: boolean) => ({type: 'PAYMENT/SET_LOADING', payload: loading} as const),
    setActualPayment: (payload: PaymentType) => ({
        type: 'PAYMENT/ACTUAL_PAYMENT', payload} as const),
    setPayType: (payType: number) => ({type: 'PAYMENT/PAYTYPE', payType} as const),
    setPayDate: (payDate: string) => ({type: 'PAYMENT/PAYDATE', payDate} as const),
    setPayNumber: (payNumber: string ) => ({type: 'PAYMENT/PAYNUMBER', payNumber} as const),
    setPayRoute: (route: string, isMatch: boolean, message: string ) => ({type: 'PAYMENT/PAYROUTE', payload: {route, isMatch, message}} as const)
}
export type ActionsTypes = InferActionTypes<typeof actions>
type ThunkType = BaseThunkType<ActionsTypes>

export const getActualPayment = ():ThunkType => async (dispatch) => {//return thunk(thunkCreator)
    let response = await api.getPayment();
    if (response.code === 200) {
        let data = response.data;
        dispatch(actions.setActualPayment(data));
        if(response.data.isFree) {
            window.location.href = `${getLang()}/search`
        }
    }
}

export const checkPayment = (payNumber: string, payDate: string, payType: string):ThunkType => async (dispatch) => {//return thunk(thunkCreator)
    let response = await api.checkPay(payNumber, payDate, payType);
    if (response.code === 200) {
        let {route, isMatch} = response.data;
        dispatch(actions.setPayRoute(route, isMatch, response.message));
        if(!isMatch) {
            window.location.href = route + '?message=' + response.message + '&isArch=false'
        }
    }
}